// @core/api/endpoints/notifications/update_contact.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateContactRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update contact
 * Updates an existing contact's information. Changes to contact values may require re-verification.
 */
export async function UpdateContact(
  contact_id: string,
  data: UpdateContactRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/contacts/:contact_id`;
  requestPath = requestPath.replace(':contact_id', encodeURIComponent(contact_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
